export enum GrowthPlanSessionStatus {
    SESSION_INCOMPLETE = 'SESSION_INCOMPLETE',
    SESSION_COMPLETE = 'SESSION_COMPLETE'
}